// adapted from http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
/* tslint:disable:no-bitwise */
export function hashCode(str: string) {
  var hash = 0,
    i,
    chr;
  if (str.length === 0) {
    return hash;
  }
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

/**
 * Slugify a string
 * @param s Any string
 */
export function toSlug(s: string) {
  if (!s) {
    return '';
  }
  s = s.toLowerCase().trim();
  s = s.replace(/ & /g, ' and ');
  s = s.replace(/[ ]+/g, '-');
  s = s.replace(/[-]+/g, '-');
  s = s.replace(/[^a-z0-9-]+/g, '');
  return s;
}



// WEBPACK FOOTER //
// ./src/common/utils/utils.ts